import { TACTICS_ARR } from '@/utils';

export type Props = {
  id: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
};

export type TacticsIds = Props[keyof Props];

export function IconSelect({ id }: Props) {
  const tacticArr = TACTICS_ARR[id];
  const [row1, row2, row3] = tacticArr;

  return (
    <div className="w-[50px] space-y-[3px]">
      <div className="flex items-center justify-center gap-[4px]">
        {[...Array(row1).keys()].map((index) => {
          return (
            <div
              key={index}
              className="w-[5px] h-[5px] rounded-full bg-gdt-blue"
            />
          );
        })}
      </div>
      <div className="flex items-center justify-center gap-[4px]">
        {[...Array(row2).keys()].map((index) => {
          return (
            <div
              key={index}
              className="w-[5px] h-[5px] rounded-full bg-gdt-blue"
            />
          );
        })}
      </div>
      <div className="flex items-center justify-center gap-[4px]">
        {[...Array(row3).keys()].map((index) => {
          return (
            <div
              key={index}
              className="w-[5px] h-[5px] rounded-full bg-gdt-blue"
            />
          );
        })}
      </div>
    </div>
  );
}
